import ReactDOM from "react-dom";
// ServiceWorker
import * as sw from "./sw";
// Page
import App from "./App";
// CSS
import "./assets/css/stripe.css";

// import "antd/dist/antd.css";

import "react-awesome-slider/dist/styles.css";
import "react-toastify/dist/ReactToastify.min.css";
import "./assets/css/main.min.css";

ReactDOM.render(<App />, document.getElementById("root"));
sw.register();
